import { Component, OnInit } from '@angular/core';
import { NotificationMessage } from '@models/notification-message';
import { NotificationService } from '@services/notification.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { ServerNotificationService } from '@services/server-notification.service';

@Component({
  selector: 'app-notifications-modal',
  templateUrl: './notifications-modal.component.html',
  styleUrls: ['./notifications-modal.component.scss'],
})
export class NotificationsModalComponent implements OnInit {

  notifications: NotificationMessage[];

  constructor(
    private notificationService: NotificationService,
    public activeModal: NgbActiveModal,
    private router: Router,
    private serverNotificationService: ServerNotificationService) {
  }

  ngOnInit() {
    this.notificationService.getNotifications().pipe(map((notifications) => {
      return notifications.map(notification => {
        if (notification.notificationType) {
          return this.serverNotificationService.setServerNotificationLocalization(notification);
        } else {
          return notification;
        }
      });
    })).subscribe(n => {
      console.log('Notifications loaded in modal:', n);
      this.notifications = n;
    });
  }

  isAnyUnread(): boolean {
    return this.notifications && this.notifications.filter(n => !n.isRead).length > 0;
  }

  markAllRead() {
    const unreadNotifications = this.notifications.filter(x => !x.isRead);
    this.notificationService.addNotificationRead(unreadNotifications.map(un => un.id)).subscribe(() => {
      this.notificationService.updateUnreadNotifications(0);
      this.activeModal.close();
    });
  }

  readNotification(notification: NotificationMessage, event: MouseEvent) {
    this.notificationService.addNotificationRead([notification.id]).subscribe(() => {
      let unreadNotificationsCount = this.notifications.filter(un => !un.isRead).length;
      unreadNotificationsCount = unreadNotificationsCount > 0 ? unreadNotificationsCount - 1 : 0;
      this.notificationService.updateUnreadNotifications(unreadNotificationsCount);
      this.activeModal.close();
    });
  }

  navigateToAll() {
    this.activeModal.close();
    window.location.assign('/order-new/notifications');
  }
}
